import {object, string} from 'yup';

export const validationSchema = object({
  name: string().required('Tag name is required'),
  status: string().required('Status is required'),
  description: string(),
  color: string().required('Color is required')
});
